import * as Sentry from "@sentry/react";
import "./instrument";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { PageError } from "./components/PageError";
import "./index.css";

// Intercept /admin-view?token=<hex> before React mounts so the router never
// sees the path (no 404) and the token is in sessionStorage before
// AuthContext's lazy useState initializer runs.
if (window.location.pathname === "/admin-view") {
  const token = new URLSearchParams(window.location.search).get("token");
  if (token) {
    sessionStorage.setItem("pendingAdminViewToken", token);
  }
  window.history.replaceState({}, "", "/dashboard");
}

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<PageError />}>
    <App />
  </Sentry.ErrorBoundary>
);
